import { updateCart, updateCartWithItems } from '../../bundles/api';
import {
  ExceptionErrorApiObject,
  getTransformedBodyAddons,
  getTransformedBodyItems,
} from '../../bundles/bundleUtils';
import { v4 as uuidv4 } from 'uuid';

import { isGlobalProduct } from '../../utils';

export const addBundleToCartAndRedirect = async ({
  bundleId,
  sellingPlan,
  itemProperties,
  addons,
  productsInAddonsCollection,
  productsWithProps,
  discountCode,
  isDynamic,
}: AddBundleToCartAndRedirectProps) => {
  try {
    const giftInformation = JSON.parse(
      sessionStorage.getItem('awt-gift-information') || '{}',
    );
    const giftItemProperties = {
      _giftFirstName: giftInformation.firstName,
      _giftLastName: giftInformation.lastName,
      _giftEmail: giftInformation.email,
      _giftNote: giftInformation.note,
    };

    const productsWithPropsAndGifts = productsWithProps.map(
      (productWithProps) => ({
        ...productWithProps,
        properties: {
          ...productWithProps.properties,
          ...giftItemProperties,
        },
      }),
    );
    const individualProductsCollection: LiquidProductInCollection[] =
      window?.reactInit?.individualProductsCollection || [];

    const productsInAddonsCollectionRaw: LiquidProductInCollection[] =
      window?.reactInit?.productsInAddonsCollection || [];

    let cartItems: (BundleCartBodyItem | BundleCartBodyAddon)[] = [];
    if (!isDynamic) {
      const bodyItem = getTransformedBodyItems(bundleId, sellingPlan, {
        ...itemProperties,
        ...giftItemProperties,
      });
      const bodyAddons = getTransformedBodyAddons(
        itemProperties,
        sellingPlan,
        addons,
        productsInAddonsCollection,
      );

      cartItems = [bodyItem, ...bodyAddons];
      if (window.bundleapp?.settings?.bab?.addToCart) {
        await window.bundleapp.settings.bab.addToCart({
          dynamic: false,
          items: [bodyItem],
          bodyAddons,
        });
      } else {
        await updateCart(
          bodyItem,
          bodyAddons,
          individualProductsCollection,
          productsInAddonsCollectionRaw,
        );
      }
    } else {
      const bodyAddons = getTransformedBodyAddons(
        { ...itemProperties, ...giftItemProperties },
        sellingPlan,
        addons,
        productsInAddonsCollection,
      );

      cartItems = [...productsWithPropsAndGifts, ...bodyAddons];
      if (window.bundleapp?.settings?.bab?.addToCart) {
        await window.bundleapp.settings.bab.addToCart({
          dynamic: true,
          items: productsWithPropsAndGifts,
          bodyAddons,
        });
      } else {
        await updateCartWithItems(
          productsWithPropsAndGifts,
          bodyAddons,
          individualProductsCollection,
          productsInAddonsCollectionRaw,
        );
      }
    }

    const shopifyRoot = window.Shopify?.routes?.root || '/';

    if (window.bundleapp?.settings?.bab?.addToCartRedirect) {
      await window.bundleapp.settings.bab.addToCartRedirect({
        cartItems,
        discountCode,
      });
    } else if (discountCode) {
      window.location.assign(
        `${shopifyRoot}discount/${discountCode}?redirect=${shopifyRoot}cart`,
      );
    } else {
      window.location.assign(`${shopifyRoot}cart`);
    }
  } catch (e) {
    if (e instanceof ExceptionErrorApiObject) {
      const cause = (e as any).cause as any;
      //TODO: Implement this MVP-5250
      //  addNotif(
      //   t(e.message as string, {
      //     stock: cause.stock,
      //     product: cause?.product,
      //   }),
      //   { type: 'error' },
      // );
    }

    if (e instanceof Error && !(e as any)?.cause) {
      if (typeof e.message === 'string') {
        // addNotif(t(e.message as string), { type: 'error' });
      }
    }
  }
};

export const getSelectedProductsWithPropsForCart = ({
  handle,
  productsInCollection,
  selectedProducts,
  baseProperties,
  isDynamic,
  sellingPlan,
}) => {
  const babUuid = uuidv4();
  const babHandle = handle;

  const selectedProductsWithProps = (productsInCollection as any[]).reduce(
    (acc, product: GlobalVariant | GlobalProduct) => {
      let variant;
      if (isGlobalProduct(product)) {
        variant = product.variants.find(({ id }) => {
          return !!Object.keys(selectedProducts).find((key) => key === `${id}`);
        });
      } else variant = product;

      if (!variant) {
        return acc;
      }

      const selectedProductCount = selectedProducts[variant.id];
      const { _bundleBoxPrice, ...baseProps } = baseProperties;
      if (selectedProductCount) {
        const productWithProps: ProductWithProps = {
          id: variant.id.toString(),
          quantity: selectedProductCount,
          properties: {
            _bundleUid: babUuid,
            _bundleHandle: babHandle,
            _bundleType: 'dynamicBaB',
            ...baseProps,
            ...(!isDynamic ? { _bundleBoxPrice } : {}),
          },
        };

        if (sellingPlan) {
          productWithProps.selling_plan = sellingPlan.toString();
        }

        return [...acc, productWithProps];
      }
      return acc;
    },
    [] as ProductWithProps[],
  );

  return selectedProductsWithProps;
};
